// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUAp9YhEFzqnBkXRmVHP0uD8ymiKir1mQ",
  authDomain: "winnomi-ai.firebaseapp.com",
  projectId: "winnomi-ai",
  storageBucket: "winnomi-ai.firebasestorage.app",
  messagingSenderId: "69627518937",
  appId: "1:69627518937:web:fa87fcade4d151193bc3c8",
  measurementId: "G-X9K6071R1Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
let analytics: any = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;
